"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceVoided = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.InvoiceVoided = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    invoice_number: typebox_1.Type.String(),
});
//# sourceMappingURL=invoice-voided.js.map